module.exports = __webpack_public_path__ + "static/img/faqs1.5a5c0aa.png";